module.exports = __webpack_public_path__ + "static/media/menu-ua-2.163aa15d.svg";